module.exports = __webpack_public_path__ + "static/media/final-result-banner.f24cd104.svg";